import { permissionManager } from "../PermissionManager/PermissionManager";
/** TODO:
Push-button
Checkbox
Radio button
Combo box
List box
Text field
Signature field
Calculation Order
Highlight Fields
Reset Form
Import form
Export form (XML, FDF, XFDF)
Document Javascript
Document Action
 */

 // to remove from home tab
export const FORM_GROUP_IN_HOME = 'home-tab-group-form';

export const FORM_IMPORT_FORM = 'import-form-tool';
export const FORM_EXPORT_FORM_XML = 'export-to-xml';
export const FORM_EXPORT_FORM_FDF = 'export-to-fdf';
export const FORM_EXPORT_FORM_XFDF = 'export-to-xfdf';
export const FORM_EXPORT_FORM_CSV = 'export-to-csv';
export const FORM_EXPORT_FORM_TXT = 'export-to-txt';

export const FORM_ASSISTANT = 'form-assistant-button';

export const FORM_RESET_FIELD = 'form-reset-field';
export const FORM_PAGE_TEMPLATE_BUTTON = 'page-template-button';
export const FORM_EDIT_XFA_FORM_BUTTON = 'xfa-form-button';
export const FORM_CALCULATION_ORDER = 'fv--showCO-btn';
export const FORM_ADD_TOOLTIP = 'fv--add-tooltip-btn';
export const FORM_HIGHLIGHT_FIELDS = 'highlight-fields-checkbox';

export const FORM_APPEND_TO_SHEET = 'append-to-sheet';
export const FORM_COMBINE_FORMS_TO_SHEET = 'combine-forms-to-sheet';

export const FORM_RECOGNITION_FORM      = 'recognition-form-button';
export const FORM_CREATE_TEXT_FIELD      = 'fv--form-designer-create-text-btn';
export const FORM_CREATE_SIGN_FIELD      = 'fv--form-designer-create-sign-btn';
export const FORM_CREATE_RADIO_BTN_FIELD = 'fv--form-designer-create-radio-button-btn';
export const FORM_CREATE_PUSH_BTN_FIELD  = 'fv--form-designer-create-push-button-btn';
export const FORM_CREATE_CHECK_BOX_FIELD = 'fv--form-designer-create-check-box-btn';
export const FORM_CREATE_COMBO_BOX_FIELD = 'fv--form-designer-create-combo-box-btn';
export const FORM_CREATE_LIST_BOX_FIELD  = 'fv--form-designer-create-list-box-btn';
export const FORM_CREATE_IMAGE_FIELD     = 'fv--form-designer-create-image-btn';
export const FORM_CREATE_DATE_FIELD      = 'fv--form-designer-create-date-btn';

export const FORM_KEEP_TOOL_SELECTED     = 'keep-tool-selected-checkbox';

export const FORM_DOCUMENT_JAVASCRIPT     = 'form-document-javascript';
export const FORM_DOCUMENT_ACTION         = 'form-document-action';
export const FORM_EDIT_ALL_JAVASCRIPT     = 'form-edit-all-javascript';
export const FORM_JAVASCRIPT_CONSOLE     = 'fv--form-javascript-console'
export const FORM_ALL_LIST = [
    FORM_IMPORT_FORM,
    FORM_ASSISTANT,
    FORM_EXPORT_FORM_XML,
    FORM_EXPORT_FORM_FDF,
    FORM_EXPORT_FORM_XFDF,
    FORM_EXPORT_FORM_CSV,
    FORM_EXPORT_FORM_TXT,
    FORM_RECOGNITION_FORM,
    FORM_CREATE_TEXT_FIELD,
    FORM_CREATE_SIGN_FIELD,
    FORM_CREATE_RADIO_BTN_FIELD,
    FORM_CREATE_PUSH_BTN_FIELD, 
    FORM_CREATE_CHECK_BOX_FIELD,
    FORM_CREATE_COMBO_BOX_FIELD,
    FORM_CREATE_LIST_BOX_FIELD,
    FORM_CREATE_IMAGE_FIELD,
    FORM_CREATE_DATE_FIELD,
    FORM_PAGE_TEMPLATE_BUTTON,
    FORM_EDIT_XFA_FORM_BUTTON,
    FORM_CALCULATION_ORDER,
    FORM_ADD_TOOLTIP,
    FORM_HIGHLIGHT_FIELDS,
    FORM_APPEND_TO_SHEET,
    FORM_KEEP_TOOL_SELECTED,
    FORM_DOCUMENT_JAVASCRIPT,
    FORM_DOCUMENT_ACTION,    
    FORM_EDIT_ALL_JAVASCRIPT,
    FORM_JAVASCRIPT_CONSOLE
]

export const FORM_MAP = {
    resetForm:{
        name: FORM_RESET_FIELD,
        title: 'phantom_online:toolbar.form.resetForm.title',
        tooltip: 'phantom_online:toolbar.form.resetForm.tooltip',
        icon:'fx-icon-ribbon_form_reset_form-32'
    },
    combineForms:{
        name: FORM_COMBINE_FORMS_TO_SHEET,
        title: 'phantom_online:toolbar.form.combineForms.title',
        icon:'fv__icon-toolbar-combine-forms-to-sheet'
    },
    addTooltip:{
        name: FORM_ADD_TOOLTIP,
        title: 'phantom_online:toolbar.form.addTooltip.title',
        tooltip: 'phantom_online:toolbar.form.addTooltip.tooltip',
        icon:'fv__icon-toolbar-add-tooltip'
    }
}
// premium features
export const FORM_PREMIUM_BTNS = [
    FORM_COMBINE_FORMS_TO_SHEET,
    FORM_RECOGNITION_FORM,
    FORM_CREATE_TEXT_FIELD,
    FORM_CREATE_SIGN_FIELD,
    FORM_CREATE_RADIO_BTN_FIELD,
    FORM_CREATE_PUSH_BTN_FIELD, 
    FORM_CREATE_CHECK_BOX_FIELD,
    FORM_CREATE_COMBO_BOX_FIELD,
    FORM_CREATE_LIST_BOX_FIELD,
    FORM_CREATE_IMAGE_FIELD,
    FORM_CREATE_DATE_FIELD,
    FORM_PAGE_TEMPLATE_BUTTON,
    FORM_EDIT_XFA_FORM_BUTTON,
    FORM_CALCULATION_ORDER,
    FORM_ADD_TOOLTIP,
    FORM_HIGHLIGHT_FIELDS,
    FORM_ASSISTANT,
    FORM_DOCUMENT_JAVASCRIPT,
    FORM_DOCUMENT_ACTION,    
    FORM_EDIT_ALL_JAVASCRIPT,
    FORM_JAVASCRIPT_CONSOLE,
    FORM_RESET_FIELD,
    FORM_APPEND_TO_SHEET,
    FORM_IMPORT_FORM,
    FORM_EXPORT_FORM_XML,
    FORM_EXPORT_FORM_FDF,
    FORM_EXPORT_FORM_XFDF,
    FORM_EXPORT_FORM_CSV,
    FORM_EXPORT_FORM_TXT,
    FORM_KEEP_TOOL_SELECTED,
];
permissionManager.registerPremiumFeatures(FORM_PREMIUM_BTNS);
permissionManager.registerCNJPPremiumFeatures(FORM_PREMIUM_BTNS);